import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import { IRequestCalloutDTO } from '../calloutRequested/types/IRequestCalloutDTOs';
import clsx from 'clsx';
import {getButtonNameForDirver} from './calloutResponseHelpers'
import CalloutStatuses from '../types/CalloutStatuses';


interface CalloutButtonForManagerProps {
    row: IRequestCalloutDTO,
    openAssignVehicleModal: any,
};

const elementWidth = 140;

const useStyles = makeStyles<Theme>((theme) => ({
    button: {
        borderWidth: 0,
        fontSize: 16, 
        fontWeight: 700, 
        fontFamily: 'lato',
        borderRadius: 6, 
        marginLeft: 5, 
        cursor: "pointer",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: elementWidth,
        height: 42,
        marginTop: 5,
        marginBottom: 5,
    },
    vehicleButton:{
        backgroundColor: "#F4B827",
        color: '#03090E',
    },
    labelStatus: {
        fontSize: 18, 
        fontWeight: 400, 
        fontFamily: 'lato',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: elementWidth
    },
    anotherVehicleButton:{
        backgroundColor: '#002047',
        color: '#F4B827',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.27)'
    },
}));

const CalloutButtonForManager: React.FC<CalloutButtonForManagerProps> = ({ 
    row, 
    openAssignVehicleModal}) => {
    const classes = useStyles();
    if(!row.status)return null;
    const status = (row.status??0);

    if(status > CalloutStatuses.teamAcknowledged){
        return (
        <div className={classes.labelStatus}>
            {getButtonNameForDirver(status, false)}
        </div>
        )
    }
    
    let buttonClass = '';
    if(status === CalloutStatuses.dispatchedToTeam){
        buttonClass= clsx(classes.button, classes.vehicleButton);
    }else if(status === CalloutStatuses.teamAcknowledged){
        buttonClass= clsx(classes.button, classes.anotherVehicleButton);
    }

    const onClickAction = () =>{
        openAssignVehicleModal(row.requestCalloutId);
    }
    
    return (
        <div>
            <button 
                className={buttonClass}
                onClick={onClickAction}
            >
                Assign
            </button> 
        </div>
    );
}

export default CalloutButtonForManager;
